import * as Yup from "yup"
import _includes from "lodash/includes"

import { cpf } from "services/utils/validation"
import { removeMaskCPF } from "services/utils/mask"

const MAX_FILE_SIZE = 2 * 1024 * 1024

const SUPPORTED_FORMATS = [
  "image/png",
  "image/jpeg",
  "application/pdf",
  "image/tiff",
  "image/x-tiff",
  "image/x-portable-pixmap"
]

export const stepOneValidation = () => {
  return Yup.object().shape({
    name: Yup.string().required("Campo obrigatório"),
    cpf: Yup.string()
      .required("Campo obrigatório")
      .test("cpf", "CPF inválido", (value) => {
        if (!value) {
          return false
        }
        const removeMask = removeMaskCPF(value)
        return cpf(removeMask)
      }),
    birthDate: Yup.string()
      .required("Campo obrigatório")
      .min(10, "Data inválida"),
    phoneNumber: Yup.string()
      .required("Campo obrigatório")
      .min(10, "Número de telefone inválido"),
    email: Yup.string().required("Campo obrigatório").email("E-mail inválido"),
    fileRG: Yup.mixed()
      .required("Campo obrigatório")
      .test("fileRG", "O arquivo deve ter no máximo 2MB", (value) => {
        if (!value) {
          return false
        }
        return value.size <= MAX_FILE_SIZE
      })
      .test("fileRG", "Formato de arquivo inválido", (value) => {
        if (!value) {
          return false
        }
        return _includes(SUPPORTED_FORMATS, value.type)
      })
  })
}
export const stepTwoValidation = () => {
  return Yup.object().shape({
    energyDistributor: Yup.string().required("Campo obrigatório"),
    issueDateOne: Yup.string()
      .required("Campo obrigatório")
      .min(10, "Data inválida"),
    billOne: Yup.string()
      .required("Campo obrigatório")
      .test("billOne", "Valor inválido", (value) => {
        if (!value) {
          return false
        }
        const normalized = value.replace(/\./g, "").replace(",", ".")

        return parseFloat(normalized) > 0
      }),
    issueDateTwo: Yup.string()
      .required("Campo obrigatório")
      .min(10, "Data inválida"),
    billTwo: Yup.string()
      .required("Campo obrigatório")
      .test("billOne", "Valor inválido", (value) => {
        if (!value) {
          return false
        }
        const normalized = value.replace(/\./g, "").replace(",", ".")

        return parseFloat(normalized) > 0
      }),
    customerNumber: Yup.string().required("Campo obrigatório"),
    accountHolder: Yup.string().oneOf(["PF", "PJ"]),
    holderName: Yup.string().when("accountHolder", {
      is: "PJ",
      then: (s) => s.strip(),
      otherwise: (s) => s.required("Campo obrigatório")
    }),

    holderCpf: Yup.string().when("accountHolder", {
      is: "PJ",
      then: (s) => s.strip(),
      otherwise: (s) => s.required("Campo obrigatório")
    }),
    holderBirthDate: Yup.string().when("accountHolder", {
      is: "PJ",
      then: (s) => s.strip(),
      otherwise: (s) => s.required("Campo obrigatório")
    }),
    holderPhoneNumber: Yup.string().when("accountHolder", {
      is: "PJ",
      then: (s) => s.strip(),
      otherwise: (s) => s.required("Campo obrigatório")
    }),
    holderEmail: Yup.string().when("accountHolder", {
      is: "PJ",
      then: (s) => s.strip(),
      otherwise: (s) => s.required("Campo obrigatório")
    })
  })
}

export const stepThreeValidation = () => {
  return Yup.object().shape({
    cep: Yup.string().required("CEP obrigatório"),
    address: Yup.string().required("Campo obrigatório"),
    number: Yup.string().required("Campo obrigatório"),
    fileEnergy: Yup.mixed()
      .required("Campo obrigatório")
      .test("fileEnergy", "O arquivo deve ter no máximo 2MB", (value) => {
        if (!value) {
          return false
        }
        return value.size <= MAX_FILE_SIZE
      })
      .test("fileEnergy", "Formato de arquivo inválido", (value) => {
        if (!value) {
          return false
        }
        return _includes(SUPPORTED_FORMATS, value.type)
      })
  })
}



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/RequestForm/components/validationForm.js